import {BookingOption} from '../enums/BookingOption';

export class CreateOrder {
  public officeId: number;
  public roomId: number;
  public bookingOption: BookingOption;
  public workPlaceName: string;
  public startTime: Date;
  public endTime: Date;
  public duration: number;
  public couponId: number;
  public confirmed: boolean;
  public monthSubscribe: boolean;
  public userId: number;
}
